<template>
    <ModalWrapper v-model="modal" :max-width="1200">
        <template v-slot:title>
            <template v-if="isLoading">
                {{ $t('stand_by') }}
            </template>
            <template v-else> {{ $t('invoices.title') }} {{ requestInfo.orderId }} </template>
        </template>
        <template v-slot:content>
            <v-progress-linear v-if="isLoading" color="primary" indeterminate class="mb-0" />
            <invoices-list
                v-show="!isLoading"
                :request-info="requestInfo"
                @issue-invoices="onIssueInvoices"
                @change-loading="onChangeLoading($event)"
            />
        </template>
    </ModalWrapper>
</template>

<script lang="ts">
    import {Component, Vue} from 'vue-facing-decorator'
    import {EventBus, SHOW_INVOICES_MODAL_EVENT} from '@/utils/event-bus'
    import InvoicesList from '~src/components/account/InvoicesList.vue'

    @Component({
        components: {
            InvoicesList,
        },
    })
    export class InvoicesModal extends Vue {
        modal = false
        requestInfo = {}
        isLoading = true

        onChangeLoading(isLoading) {
            this.isLoading = isLoading
        }

        mounted() {
            EventBus.$on(SHOW_INVOICES_MODAL_EVENT, this.showModal)
        }

        beforeUnmount() {
            EventBus.$off(SHOW_INVOICES_MODAL_EVENT, this.showModal)
        }

        async showModal(rq) {
            this.requestInfo = rq
            this.modal = true
        }

        onIssueInvoices() {
            this.modal = false
        }
    }

    export default InvoicesModal
</script>
